<script lang="tsx">
import type { CSSProperties } from 'vue'
import { computed, defineComponent, unref } from 'vue'
import { Tooltip } from 'ant-design-vue'
import { useDesign, getSlot } from '@tni-plus/hooks'
import { isString, getPopupContainer } from '@tni-plus/utils'
import { helpProps } from './help'

export default defineComponent({
  name: 'TpHelp',
  props: helpProps,
  components: {
    Tooltip,
  },
  setup(props, { slots }) {
    const { prefixCls } = useDesign('basic-help')
    const getTooltipStyle = computed(
      (): CSSProperties => ({ color: props.color, fontSize: props.fontSize })
    )
    const getOverlayStyle = computed(
      (): CSSProperties => ({ maxWidth: props.maxWidth })
    )

    const renderTitle = () => {
      const textList = props.text

      if (isString(textList)) return <p>{textList}</p>

      if (Array.isArray(textList)) {
        return textList.map((text, index) => {
          return (
            <p key={index}>
              {props.showIndex ? `${index + 1}.` : ''}
              {text}
            </p>
          )
        })
      }
    }

    return () => {
      return (
        <Tooltip
          overlayClassName={`${prefixCls}__wrap`}
          title={<div style={unref(getTooltipStyle)}>{renderTitle()}</div>}
          autoAdjustOverflow={true}
          overlayStyle={unref(getOverlayStyle)}
          placement={props.placement as 'right'}
          getPopupContainer={() => getPopupContainer()}
        >
          <span class={prefixCls}>{getSlot(slots)}</span>
        </Tooltip>
      )
    }
  },
})
</script>
